import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  ContentChild,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import { ButtonAppareance, ButtonColor, ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { DxActionSheetComponent, DxActionSheetModule } from 'devextreme-angular/ui/action-sheet';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DxTemplateModule } from 'devextreme-angular/core';

import { NgTemplateOutlet } from '@angular/common';
import { IconChevronDownComponent } from '@pedix-workspace/angular-ui-icons';

@Component({
  selector: 'pxw-action-sheet',
  templateUrl: './action-sheet.component.html',
  styleUrls: ['./action-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgTemplateOutlet,
    ButtonComponent,
    IconChevronDownComponent,
    DxActionSheetModule,
    DxTemplateModule,
  ],
})
export class ActionSheetComponent implements OnInit {
  @ContentChild('buttonTemplate') buttonTemplate: TemplateRef<any>;
  @ViewChild(DxActionSheetComponent) actionSheetRef: DxActionSheetComponent;

  @Input() label: string;
  @Input() appareance: ButtonAppareance = 'solid';
  @Input() background: ButtonColor = 'silver';
  @Input() cancelText: string;
  @Input() width = 160;
  @Input() disabled = false;
  @Input() size: 'sm' | 'md' = 'md';

  usePopover: boolean;

  get device() {
    return this.usePopover ? 'desktop' : 'mobile';
  }

  private deviceDetector = inject(DeviceDetectorService);

  ngOnInit(): void {
    this.usePopover = this.deviceDetector.isMobile() ? false : true;
  }

  // NOTE: method is declared this way to preserve "this" reference
  toggleActionSheet = () => {
    this.actionSheetRef.visible = !this.actionSheetRef.visible;
  };
}
